module.exports = __webpack_public_path__ + "img/Raptor Esport Logo Template.jpg";